import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { DealerList } from '../models/models'

export class ListDealerApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/orderReport/DailyOrderDealerList',
      requesterInfo,
    })
  }

  public async listDealers(): Promise<DealerList[]> {
    return await this.getAsync<DealerList[]>()
  }
}
